import React, { useCallback, useEffect, useMemo } from "react";
import { useFormik } from "formik";
import { useQuery } from "@tanstack/react-query";

import { getAxios } from "../../Services/commonService";
import { API_GET_SERVERS } from "../../utils/api/ApiConstant";
import Label from "../UI/Label";
import CustomSelect from "../UI/CustomSelect";
import Button from "../UI/Button";
import DatePickerComponent from "../UI/DatePickerComponent";

const INITIAL_VALUE = {
  server: { label: "All", value: "All" },
  exchange: { label: "All", value: "All" },
  script: { label: "All", value: "All" },
  PositionDate: new Date(new Date().getTime() - 24 * 60 * 60 * 1000),
};

const UserWisePositionHistoryFilter = ({
  handleFilterChange,
  positionList,
  refetch,
  isShow,
  setPayloadData,
}) => {
  // const { values, handleSubmit, resetForm, setFieldValue } = useFormik({
  //   initialValues: {
  //     server: INITIAL_VALUE?.server,
  //     exchange: INITIAL_VALUE?.exchange,
  //     script: INITIAL_VALUE?.script,
  //     PositionDate: INITIAL_VALUE?.PositionDate,
  //   },
  //   onSubmit: (value) => {
  //     const payload = {
  //       server: value.server?.value,
  //       exchange: value.exchange?.value,
  //       script: value.script?.value,
  //       PositionDate: value.PositionDate,
  //     };
  //     handleFilterChange({ filterData: payload });
  //   },
  // });

  const { isLoading, data: serverList } = useQuery({
    queryKey: ["serverList"],
    queryFn: async () => {
      const res = await getAxios({ url: API_GET_SERVERS, params: {} });
      return res || []; // Assuming API response structure
    },
  });

  const serverOptions = useMemo(
    () =>
      serverList
        ?.filter((server) => server !== "All")
        .sort((a, b) => a?.localeCompare(b))
        .map((server) => ({
          label: server,
          value: server,
        })),
    [serverList],
  );

  useEffect(() => {
    if (!serverOptions) return;

    setPayloadData((prev) => ({
      ...prev,
      server: serverOptions?.[0].value,
    }));
  }, [serverOptions]);

  const { values, handleSubmit, resetForm, setFieldValue } = useFormik({
    initialValues: {
      server: serverOptions?.[0],
      exchange: INITIAL_VALUE?.exchange,
      script: INITIAL_VALUE?.script,
      PositionDate: INITIAL_VALUE?.PositionDate,
    },
    enableReinitialize: true,
    onSubmit: (value) => {
      const payload = {
        server: value.server?.value,
        exchange: value.exchange?.value,
        script: value.script?.value,
        PositionDate: value.PositionDate,
      };
      handleFilterChange({ filterData: payload });
    },
  });

  const ExchangesOption =
    positionList?.length > 0 &&
    [
      { label: "All", value: "All" },
      ...Array.from(
        new Set(positionList?.map((item) => item?.ExchangeName)),
      ).map((name) => ({
        label: name,
        value: name,
      })),
    ].sort((a, b) => a.label?.localeCompare(b.label));

  const selectedExchange = values.exchange?.value;

  const filteredTradesForScript = positionList?.filter((item) => {
    const matchesExchange =
      selectedExchange === "All" || item?.ExchangeName === selectedExchange;
    return matchesExchange;
  });

  const scriptOptions =
    filteredTradesForScript?.length > 0 &&
    [
      { label: "All", value: "All" },
      ...Array.from(
        new Set(filteredTradesForScript?.map((item) => item?.Script)),
      ).map((name) => ({
        label: name,
        value: name,
      })),
    ].sort((a, b) => a.label?.localeCompare(b.label));

  const handleFormReset = useCallback(() => {
    resetForm();
    handleFilterChange({
      filterData: {
        server: serverOptions?.[0]?.value,
        exchange: INITIAL_VALUE?.exchange?.value,
        script: INITIAL_VALUE?.script?.value,
        PositionDate: INITIAL_VALUE?.PositionDate,
      },
    });
  }, [serverOptions]);

  return (
    <div>
      <form
        className={`date-input-main ${isShow ? "" : "d-none"}`}
        onSubmit={handleSubmit}
      >
        <div className="row m-0 p-0 align-items-end">
          <div className="col-lg-2 col-6 m-0 p-1">
            <div className="date-input-box">
              <Label htmlFor="PositionDate" className="lead_text">
                Position Date
              </Label>
              <DatePickerComponent
                selectedDate={values.PositionDate}
                id="PositionDate"
                onChange={(date) => setFieldValue("PositionDate", date)}
                placeholderText="Pick a date"
              />
            </div>
          </div>
          <div className="col-lg-2 col-6 m-0 p-1">
            <div className="date-input-box">
              <Label htmlFor="" className="lead_text">
                Servers
              </Label>
              <CustomSelect
                className="dropdown-control "
                options={serverOptions}
                onChange={(selectedOption) => {
                  setFieldValue("server", selectedOption);
                }}
                value={values.server}
                name="server"
                id="server"
                isClearable={false}
              />
            </div>
          </div>
          {/* <div className="col-lg-2 col-6 m-0 p-1">
            <div className="date-input-box">
              <Label htmlFor="" className="lead_text">
                Exchanges
              </Label>
              <CustomSelect
                className="dropdown-control "
                options={ExchangesOption}
                onChange={(selectedOption) => {
                  setFieldValue("exchange", selectedOption);
                }}
                value={values.exchange}
                name="exchange"
                id="exchange"
                isClearable={false}
              />
            </div>
          </div>
          <div className="col-lg-2 col-12 m-0 p-1">
            <div className="date-input-box">
              <Label htmlFor="" className="lead_text">
                Script
              </Label>
              <CustomSelect
                className="dropdown-control "
                options={scriptOptions}
                onChange={(selectedOption) => {
                  setFieldValue("script", selectedOption);
                }}
                value={values.script}
                name="script"
                id="script"
                isClearable={false}
              />
            </div>
          </div> */}

          <div className="col-lg-1 col-6 m-0 p-1">
            <Button
              type="submit"
              className="ban-man-box history-btn"
              title="View"
            >
              View
            </Button>
          </div>
          <div className="col-lg-1 col-6 m-0 p-1">
            <Button
              type="button"
              className="ban-man-box clear-btn"
              title="Clear"
              onClick={handleFormReset}
            >
              Clear
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default UserWisePositionHistoryFilter;
